// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDJAUzjhPoyV1BtFqY9bGJSxGGkSX8pydA",
  authDomain: "shannabiopeluqueriapersonal.firebaseapp.com",
  projectId: "shannabiopeluqueriapersonal",
  storageBucket: "shannabiopeluqueriapersonal.firebasestorage.app",
  messagingSenderId: "966266743949",
  appId: "1:966266743949:web:111b1062fdb972083ec6c4",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios
export const db = getFirestore(app);
export const auth = getAuth(app);
